<div class="content-info">
    <div class="content-title">
      <h3 class="title">Stock Transfer</h3>
      <!-- <div class="title-actions">
        <button type="submit" class="btn btnprimary" [disabled]="transferForm.invalid">
          <i class="bi bi-arrow-right-circle"></i> Transfer Stock
        </button>
      </div>  -->
    </div>
  
    <form [formGroup]="transferForm" (ngSubmit)="submitTransfer()" class="row g-3 input-fileds">
      
      <!-- Source Location -->
      <div class="col-md-4 form-group">
        <label class="form-label">From (Location)</label>
        <select class="form-select form-control" formControlName="sourceLocationId">
          <option value="">-- Select Location --</option>
          @for (loc of allLocations; track loc.id) {
            <option [value]="loc.id">{{ loc.name }}</option>
          }
        </select>
      </div>
  
      <!-- Product -->
      <div class="col-md-4 form-group">
        <label class="form-label">Product</label>
        <select class="form-select form-control" formControlName="productId" [disabled]="!availableProducts.length">
          <option value="">-- Select Product --</option>
          @for (p of availableProducts; track p.id) {
            <option [value]="p.id">{{ p.name }}</option>
          }
        </select>
      </div>
  
      <!-- Target Location -->
      <div class="col-md-4 form-group">
        <label class="form-label">To (Location)</label>
        <select class="form-select form-control" formControlName="targetLocationId">
          <option value="">-- Select Location --</option>
          @for (loc of targetLocations; track loc.id) {
            <option [value]="loc.id">{{ loc.name }}</option>
          }
        </select>
      </div>
  
      <!-- Quantity -->
      <div class="col-md-4 form-group">
        <label class="form-label">Quantity</label>
        <input type="number" class="form-control" formControlName="quantity" placeholder="Enter quantity" />
      </div>
  
      <!-- Remarks -->
      <div class="col-md-8 form-group">
        <label class="form-label">Remarks</label>
        <input type="text" class="form-control" formControlName="remarks" placeholder="Optional remarks..." />
      </div>
  
   
      <div class="col-12 text-end">
        <button type="submit" class="btn btnprimary" [disabled]="transferForm.invalid">
          <i class="bi bi-arrow-right-circle"></i> Transfer Stock
        </button>
      </div>
  
    </form>
  </div>
  